import React, { useEffect, useState } from "react";
import { showErrorToast, showSuccessToast } from "../../assets/toastUtils";
import styles from "./NewGetQuoteDownloadPopup.module.scss";
import locationIcon from "../../assets/images/location_icon.png";
import destinationIcon from "../../assets/images/experienc_icon.png";
import securityIcon from "../../assets/images/security_icon.png";
import customerIcon from "../../assets/images/customer_icon.png";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { calculateToDatePlus } from "../../utils/utils";

const NewGetQuoteDownloadPopup = ({
    package_id,
    setshowRatePopup,
    handleDownload,
    packageData,
    selectedCategory
}) => {
    // const [showRatePopup, setShowRatePopup] = useState(false);
    const userType = localStorage.getItem("userType");
    const [guest, setGuest] = useState(2);
    const [children, setChildren] = useState(0);
    const [childAge, setChildAge] = useState([]);

    const baseUrl = 'https://www.mountainmysteries.com' + window?.location?.pathname;

    const [formData, setFormData] = useState({
        company_name: "",
        name: "",
        phone: "",
        email: "",
        content: '',
        querry_detail: "",
        country: "",
        state: "",
        city: "",
        address: "",
        travel_date: "",
        leadSubject: "Download Itinerary",
        start_date: "",
        end_date: "",
        source_type: "",
        source: "website",
        type: "package",
        adult: "",
        children: "",
        reference_name_information: "",
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleShowRatePopup = (e) => {
        e.stopPropagation();
        setshowRatePopup(false);
    };

    const postDataHandle = (e) => {
        e.preventDefault();
        const myHeaders = new Headers();

        myHeaders.append("Accept", "application/json");
        myHeaders.append("key", process.env.REACT_APP_API_KEY);

        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            leadName: formData?.company_name,

            leadPhone: formData?.phone,

            leadSubject: formData?.subject,

            leadEmail: formData?.email,

            package_id: package_id,

            leadDetail: formData?.querry_detail,

            leadSource: "Website",

            query_company: formData?.name,

            query_type: "agent",

            travel_date: formData?.travel_date,

            leadSubject: "Download Itinerary",
        });

        const requestOptions = {
            method: "POST",

            headers: myHeaders,

            body: raw,

            redirect: "follow",
        };

        fetch(`${process.env.REACT_APP_APP_URL}/api/v1/send-query`, requestOptions)
            .then((response) => response.json())

            .then((result) => {
                if (result.success) {
                    setshowRatePopup(false);
                    handleDownload();
                }
            })

            .catch((error) => console.error(error));
    };

    const sendQuery = async (e) => {
        e.preventDefault();
        try {
            const myHeaders = {
                Accept: "application/json",
                "Content-Type": "application/json",
                key: process.env.REACT_APP_BASE_API_KEY,
                Cookie: process.env.REACT_APP_COOKIE,
            };

            const formattedDestination = packageData?.packageDestination?.map(
                (destination) => destination.destinationId
            );

            const sourceType = userType === "agent" ? "agent" : userType === "vendor" ? "vendor" : "customer";
            const body = JSON.stringify({
                name: formData?.name,
                email: formData?.email,
                content: formData?.querry_detail,
                source: "website",
                source_type: sourceType,
                type: "package",

                start_date_information: formData.start_date,
                end_date_information: formData.end_date,

                destination_start_information:
                    packageData?.packageItinerary[0]?.startDestination,
                destination_end_information:
                    packageData?.packageItinerary[0]?.endDestination,

                adults_information: formData.adult,
                children_information: formData.children,

                hotel_category_information: packageData?.hotelCategory,
                room_category_information: ["budget"],
                all_destinations_information: formattedDestination,
                reference_name_information: formData?.name,
            });

            const response = await fetch(
                `${process.env.REACT_APP_BASE_URL}/api/v1/website/query/create`,
                {
                    method: "POST",
                    headers: myHeaders,
                    body: body,
                    redirect: "follow",
                }
            );

            const result = await response.json();
            if (result.success) {
                showSuccessToast(result.message);
                handleDownload();
                setshowRatePopup(false);
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const guestParam = queryParams.get('guest');
        const childrenParam = queryParams.get('children');
        const childAges = [];
        let i = 1;
        while (queryParams.has(`childAge[${i}]`)) {
            childAges.push(queryParams.get(`childAge[${i}]`));
            i++;
        }

        setGuest(guestParam);
        setChildren(childrenParam);
        setChildAge(childAges);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
        myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

        const destinationIds = packageData?.packageDestination?.map(dest => dest.destinationId);

        const firstDestination = destinationIds?.length > 0 ? destinationIds[0] : null;
        const lastDestination = destinationIds?.length > 0 ? destinationIds[destinationIds.length - 1] : null;

        const sourceType = userType === "agent" ? "agent" : userType === "vendor" ? "vendor" : "customer";

        const rawData = {
            name: formData?.name,
            email: formData?.email,
            phone_information: formData?.phone,
            travel_date_information: formData?.travel_date,
            guide_required_information: formData?.guide_required,
            content: formData?.content,
            source: formData?.source,
            source_type: sourceType,
            type: formData?.type,


            adults_information: guest ? guest : 2,
            children_information: children,
            child_age_information: childAge,
            // start_date_information: formData.start_date_information,
            // end_date_information: formData.end_date_information,

            start_date_information: formData.start_date_information
                ? format(formData.start_date_information, 'yyyy-MM-dd')
                : "",
            end_date_information: formData.end_date_information,
            // end_date_information: formData.end_date_information
            //     ? format(formData.end_date_information, 'yyyy-MM-dd')
            //     : "",

            hotel_category_information: [selectedCategory],
            room_category_information: [selectedCategory],
            destination_start_information: firstDestination,
            destination_end_information: lastDestination,
            all_destinations_information: destinationIds,
            package_name_information: packageData?.packageName,
            package_id_information: packageData?.packageId,
            package_url_information: baseUrl,
        };

        try {
            const response = await fetch(
                `${process.env.REACT_APP_BASE_URL}/api/v1/website/query/create`,
                {
                    method: "POST",
                    headers: myHeaders,
                    body: JSON.stringify(rawData),
                    redirect: "follow",
                }
            );
            const result = await response.json();
            if (result.success) {
                showSuccessToast(result.message || "Form submitted successfully!");
                handleDownload();
                setshowRatePopup(false);
                setFormData({
                    name: "",
                    email: "",
                    phone: "",
                    travel_date: "",
                    adult: "",
                    time: "",
                    source: "website",
                    content: "",
                    source_type: "",
                });
            } else {
                showErrorToast(
                    result.message || "An error occurred. Please try again."
                );
            }
        } catch (error) {
            showErrorToast("An error occurred. Please try again.");
            console.error(error);
        }
    };

    return (
        <div className="bg-backdrop packagequery_form_backdrop">
            {" "}
            <div className={styles.new_popup_flex}>
                <div className={styles.new_popup_colored}>
                    <div className="flex align_items_center h-full">
                        <div>
                            <div>
                                <h4>Over 22+ Years of Experience</h4>
                                <div className={styles.choose_us}>
                                    <div className={styles.highlight}>
                                        <img src={locationIcon} alt="location-icon" />
                                        <span>All in one platform</span>
                                    </div>
                                    <div className={styles.highlight}>
                                        <img src={destinationIcon} alt="destination-icon" />
                                        <span>Expertise in Mountain Destinations</span>
                                    </div>
                                    <div className={styles.highlight}>
                                        <img src={securityIcon} alt="security-icon" />
                                        <span> Handpicked Stays & Experiences</span>
                                    </div>
                                    <div className={styles.highlight}>
                                        <img src={customerIcon} alt="customer-icon" />
                                        <span>Safety & security</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <form
                    onSubmit={handleSubmit}
                    className={styles.new_popup_form}
                >
                    <h4 style={{ fontSize: "18px", fontWeight: "600", textTransform: "uppercase" }}>
                        Download Itinerary
                    </h4>
                    <div
                        className="dashboard_checkin_modal_close_btn"
                        onClick={handleShowRatePopup}
                        style={{
                            cursor: "pointer",
                            position: "absolute",
                            top: "10px",
                            right: "10px",
                        }}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                        >
                            <path
                                d="M1 12.7464L13 0.851318"
                                stroke="#AAAAAA"
                                strokeWidth="1.2"
                            />
                            <path
                                d="M13 12.7463L0.999999 0.851296"
                                stroke="#AAAAAA"
                                strokeWidth="1.2"
                            />
                        </svg>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                            marginTop: "20px",
                        }}
                    >
                        <div>
                            <label htmlFor="name">Name:</label>
                            <input
                                required
                                className="w-full"
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleInputChange}
                                placeholder="Your Name"
                                style={{
                                    padding: "10px",
                                    borderRadius: "4px",
                                    border: "1px solid #ccc",
                                }}
                            />
                        </div>


                        {/* <input
            required
            className="w-full"
            type="text"
            name="company_name"
            value={formData.company_name}
            onChange={handleInputChange}
            placeholder="Company Name"
            style={{
              padding: "10px",
              borderRadius: "4px",
              border: "1px solid #ccc",
            }}
          /> */}

                        <div className="input-flex">
                            <div>
                                <label htmlFor="phone">Phone:</label>
                                <input
                                    required
                                    className="w-full"
                                    type="number"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleInputChange}
                                    placeholder="Phone"
                                    style={{
                                        padding: "10px",
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                    }}
                                />
                            </div>
                            <div>
                                <label htmlFor="email">Email:</label>
                                <input
                                    required
                                    className="w-full"
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    placeholder="Email"
                                    style={{
                                        padding: "10px",
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                    }}
                                />
                            </div>
                        </div>

                        {/* <div>
                            <label htmlFor="source_type">Are you Agent:</label>
                            <select
                                className="w-full"
                                name="source_type"
                                value={formData.source_type}
                                onChange={handleInputChange}
                            >
                                <option value="" disabled>
                                    Select an option
                                </option>
                                <option value="agent">Yes</option>
                                <option value="customer">No</option>
                            </select>
                        </div> */}
                        <div className={styles.package_query_input_100}>
                            <label htmlFor="start_date_information">Travel Date:</label>
                            <div className={styles.new_date_picker_wrapper}>
                                <DatePicker
                                    selected={formData?.start_date_information}
                                    // onChange={(date) => setFormData(date)}
                                    onChange={(date) => {
                                        setFormData(prev => ({
                                            ...prev,
                                            start_date_information: date,
                                            end_date_information: calculateToDatePlus(date, packageData?.totalDays + 1)
                                        }))
                                    }}
                                    portalId="root-portal NewUIReactDatePicker PackageQueryFormDatePickerWrapper"
                                    popperPlacement="bottom-start"
                                    className="PackageQueryFormDatePickerWrapper2"
                                    minDate={new Date()}
                                    dateFormat="dd MMM, yyyy"
                                    placeholderText={
                                        formData?.start_date_information ? format(formData?.start_date_information, "dd MMM, yyyy") : "Travel Date"
                                    }
                                />
                            </div>
                            {/* <div>
                                <label htmlFor="source_type">Start Date:</label>
                                <input
                                    required
                                    className="w-full"
                                    type="date"
                                    name="start_date"
                                    value={formData.start_date}
                                    // onChange={handleInputChange}
                                    placeholder="Travel Date"
                                    onChange={(date) => {
                                        setFormData(prev => ({
                                            ...prev,
                                            start_date_information: date,
                                            end_date_information: calculateToDatePlus(date, packageData?.totalDays + 1)
                                        }))
                                    }}
                                    style={{
                                        padding: "10px",
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                    }}
                                />
                            </div> */}
                            {/* <div>
                                <label htmlFor="source_type">End Date:</label>
                                <input
                                    required
                                    className="w-full"
                                    type="date"
                                    name="end_date"
                                    value={formData.end_date}
                                    onChange={handleInputChange}
                                    placeholder="End Date"
                                    style={{
                                        padding: "10px",
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                    }}
                                />
                            </div> */}
                        </div>

                        {/* <div className="input-flex">
                            <div>
                                <label htmlFor="source_type">Adult:</label>
                                <input
                                    required
                                    className="w-full"
                                    type="number"
                                    name="adult"
                                    value={formData.adult}
                                    onChange={handleInputChange}
                                    placeholder="Adult"
                                    style={{
                                        padding: "10px",
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                    }}
                                />
                            </div>
                            <div>
                                <label htmlFor="source_type">Children:</label>
                                <input
                                    required
                                    className="w-full"
                                    type="number"
                                    name="children"
                                    value={formData.children}
                                    onChange={handleInputChange}
                                    placeholder="Children"
                                    style={{
                                        padding: "10px",
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                    }}
                                />
                            </div>
                        </div> */}

                        {/* <div className="input-flex">
            <div>
              <label htmlFor="source_type">Are you Agent:</label>
              <select
                className="w-full"
                name="source_type"
                value={formData.source_type}
                onChange={handleInputChange}
              >
                <option value="" disabled>
                  Select an option
                </option>
                <option value="agent">Yes</option>
                <option value="customer">No</option>
              </select>
            </div>
          </div> */}

                        <textarea
                            className="w-full"
                            required
                            type="text-area"
                            name="content"
                            value={formData.content}
                            onChange={handleInputChange}
                            placeholder="Querry Detail"
                            style={{
                                padding: "10px",
                                borderRadius: "4px",
                                border: "1px solid #ccc",
                                height: "100px",
                                overflow: "scroll",
                            }}
                        />
                        {/* <div className="search-btn-width"> */}
                        <button type="submit" className={styles.common_btn}>
                            Download Itinerary
                        </button>
                        {/* </div> */}
                    </div>
                </form>
            </div>
        </div>
    );
};

export default NewGetQuoteDownloadPopup;